import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SendBexioCollectiveInvoiceCommand } from '../models/commandModels/SendBexioCollectiveInvoiceCommand';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { UrlResolverService } from './url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class BexioService {
    private readonly urlResolver = inject(UrlResolverService);
    private readonly pcxCommandUrl: string = this.urlResolver.getPcxCommandUrl();
    private readonly pcxQueryUrl: string = this.urlResolver.getPcxQueryUrl();
    private readonly externalBexioUrl: string = this.urlResolver.getExternalBexioUrl();
    constructor(private httpClient: HttpClient) {}

    public SendBexioCollectiveInvoice(payload: SendBexioCollectiveInvoiceCommand) {
        return this.httpClient.post(
            `${this.externalBexioUrl}SendBexioCollectiveInvoice`,
            payload,
            SCConfig.HttpCommonOptions
        );
    }
}
